import { render, staticRenderFns } from "./itemWrapper.vue?vue&type=template&id=277d180a&scoped=true"
import script from "./itemWrapper.vue?vue&type=script&lang=js"
export * from "./itemWrapper.vue?vue&type=script&lang=js"
import style0 from "./itemWrapper.vue?vue&type=style&index=0&id=277d180a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277d180a",
  null
  
)

export default component.exports